import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IMarketingDetails, IisExist, IMarketingOptionExistsModel, IPostResponse, ISaveDeleteResponse, ICodeExists, INameExists } from '../Shared/interface';
import { AppInsightsService } from './app-insights.service';
import { ICompetitorList, ICompetitorDetails, IWebHookList, IWebHookDetails, IFacilityCompetitorSettings, IFacilityCompetitorCandidate, IUnitTypeMappingSummary, IFacilityPickerItem } from '../Shared/models/Competitor';
import {AppService} from './app.service';
import { ITenantMapdetails, ICompetitorRateComparisonRow, IStorTrackFacilityDetails, ICompetitorUnitTypeMarketRate, IFacilityMapLocation, IUnitTypeMarketRatesRequest  } from '../Shared/interface2';

@Injectable({
    providedIn: 'root',
})

export class MarketingService {

    private baseURL = this.appService.config.apiBaseUrl;


    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) {

    }

    getMarketing(): Observable<IMarketingDetails[]> {
        return this.http.get<IMarketingDetails[]>(
            `${this.baseURL}/Marketing/GetMarketingQuestions`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const market = res.body as IMarketingDetails[];
                    return market;
                }),
                catchError(this.handleError)
            );
    }

    getMarketingForOp(): Observable<IMarketingDetails[]> {
        return this.http.get<IMarketingDetails[]>(
            `${this.baseURL}/Marketing/GetMarketingQuestionsForOp`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const market = res.body as IMarketingDetails[];
                    return market;
                }),
                catchError(this.handleError)
            );
    }

    saveMrktDemoDetail(merch: IMarketingDetails): Observable<IPostResponse> {

        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
      //  const url = `${this.baseURL}/Marketing/SaveMarketingQuestion`;
        if (merch.Id === 0) {
            url = `${this.baseURL}/Marketing/CreateMarketingQuestion`;
        }
        else {
            url = `${this.baseURL}/Marketing/UpdateMarketingQuestion`;
        }
        return this.http.post<IPostResponse>(url, merch, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getMrktDemoDetail(id: number): Observable<IMarketingDetails> {
        return this.http.get<IMarketingDetails>(
            `${this.baseURL}/Marketing/GetMarketingQuestionById?id=${id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const mrktDetail = res.body as IMarketingDetails;
                    return mrktDetail;
                }),
                catchError(this.handleError)
            );

    }

    DeleteMrkt(mrktId: number) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.post<boolean>(`${this.baseURL}/Marketing/DeleteMarketingQuestion?id=${mrktId}`, options);
    }


    getIsmarketingQuestionExists(MrktQuestn: string): Observable<IisExist> {
        return this.http.get<IisExist>(
            `${this.baseURL}/Marketing/GetMarketingQuestionExists?question=${MrktQuestn}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const isExist = result.body as IisExist;
                    return isExist;
                }
                ),
                catchError(this.handleError)
            );
    }


    getIsmarketingOptionExists(MrkQuestionId: number, MrktOption: string): Observable<IMarketingOptionExistsModel> {

        return this.http.get<IMarketingOptionExistsModel>(

            `${this.baseURL}/Marketing/GetMarketingOptionExists?questionId=${MrkQuestionId}&option=${MrktOption}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const isExist = result.body as IMarketingOptionExistsModel;
                    return isExist;
                }
                ),
                catchError(this.handleError)
            );
    }

    getCompetitorList(): Observable<ICompetitorList[]> {
        return this.http.get<ICompetitorList[]>(
            `${this.baseURL}/Competitor/GetCompetitorList`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const competitors = res.body as ICompetitorList[];
                    return competitors;
                }),
                catchError(this.handleError)
            );
    }

    getCompetitorListForOp(): Observable<ICompetitorList[]> {
        return this.http.get<ICompetitorList[]>(
            `${this.baseURL}/Competitor/GetCompetitorListForOp`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const competitors = res.body as ICompetitorList[];
                    return competitors;
                }),
                catchError(this.handleError)
            );
    }

    getCompetitorDetails(Id: number): Observable<ICompetitorDetails> {
        return this.http.get<ICompetitorDetails>(
            `${this.baseURL}/Competitor/GetCompetitorDetails?competitorId=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const competitorDetails = res.body as ICompetitorDetails;
                    return competitorDetails;
                }),
                catchError(this.handleError)
            );
    }

    saveCompetitor(details: any): Observable<boolean> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/Competitor/SaveCompetitor`;
        return this.http.post<ISaveDeleteResponse>(url, details, options)
            .pipe(
                map(res => {
                    return res.Success;
                }),
                catchError(this.handleError)
            );
    }

    isCompetitorCodeExist(Code: string): Observable<ICodeExists> {
        return this.http.get<ICodeExists>(
            `${this.baseURL}/Competitor/GetIsCompetitorCodeExist?code=${Code}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const CodeExist = result.body as ICodeExists;
                    return CodeExist;
                }
                ),
                catchError(this.handleError)
            );
    }

    isCompetitorNameExist(Name: string): Observable<INameExists> {
        return this.http.get<INameExists>(
            `${this.baseURL}/Competitor/GetIsCompetitorNameExist?name=${Name}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const NameExist = result.body as INameExists;
                    return NameExist;
                }
                ),
                catchError(this.handleError)
            );
    }

    deleteCompetitor(Id: number) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<boolean>(`${this.baseURL}/Competitor/DeleteCompetitor?compId=${Id}`, options);
    }


    GetWebhooksList(): Observable<IWebHookList[]> {
        return this.http.get<IWebHookList[]>(
            `${this.baseURL}/WebHooks/GetWebhooksList`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as IWebHookList[];
                }),
                catchError(this.handleError)
            );
    }

    
    GetWebhookDetails(Id: number): Observable<IWebHookDetails> {
        return this.http.get<IWebHookDetails>(
            `${this.baseURL}/WebHooks/GetWebhookDetails?Id=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const competitorDetails = res.body as IWebHookDetails;
                    return competitorDetails;
                }),
                catchError(this.handleError)
            );
    }

    
    SaveWebhooks(details: IWebHookDetails): Observable<boolean> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        url = `${this.baseURL}/WebHooks/SaveWebhooks`;
        return this.http.post<ISaveDeleteResponse>(url, details, options)
            .pipe(
                map(res => {
                    return res.Success;
                }),
                catchError(this.handleError)
            );
    }

    GetGeoLocationTenantMappings(facilityId) : Observable<ITenantMapdetails> {
        return this.http.get<ITenantMapdetails>(
          `${this.baseURL}/TenantMapping/GetGeoLocationTenantMappings?facilityId=${facilityId}`,
          { observe: 'response' })
          .pipe(
            map(res => {
              const geoLocationList = res.body as ITenantMapdetails;
              return geoLocationList;
            }),
            catchError(this.handleError)
          );
      }

    // Store → Competitor Mapping / Unit Type Mapping (Market Analysis-Defined Competitors).
    getStorTrackEnabledFacilities(): Observable<IFacilityPickerItem[]> {
        return this.http.get<IFacilityPickerItem[]>(
            `${this.baseURL}/Competitor/GetStorTrackEnabledFacilities`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const facilities = res.body as IFacilityPickerItem[];
                    return facilities;
                }),
                catchError(this.handleError)
            );
    }

    getCompetitorMarketAnalysisLicense(): Observable<boolean> {
        return this.http.get<boolean>(
            `${this.baseURL}/Competitor/GetCompetitorMarketAnalysisLicense`,
            { observe: 'response' })
            .pipe(
                map(res => !!res.body),
                catchError(this.handleError)
            );
    }

    getFacilityCompetitorSettings(facilityId: number): Observable<IFacilityCompetitorSettings> {
        return this.http.get<IFacilityCompetitorSettings>(
            `${this.baseURL}/Competitor/GetFacilityCompetitorSettings?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const settings = res.body as IFacilityCompetitorSettings;
                    return settings;
                }),
                catchError(this.handleError)
            );
    }

    /** Story 5.1/5.2: batched (one call per screen load, not per row) competitor market rate lookup for a set of unit types. POST since the unit type id list can be long. */
    getUnitTypeMarketRates(facilityId: number, unitTypeIds: number[]): Observable<ICompetitorUnitTypeMarketRate[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const request: IUnitTypeMarketRatesRequest = { FacilityId: facilityId, UnitTypeIds: unitTypeIds || [] };
        return this.http.post<ICompetitorUnitTypeMarketRate[]>(
            `${this.baseURL}/Competitor/GetUnitTypeMarketRates`, request, options)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    /** Story 5.1/5.2: own-facility coordinates/name for the shared competitor-market-map's "own facility" pin. */
    getFacilityMapLocation(facilityId: number): Observable<IFacilityMapLocation> {
        return this.http.get<IFacilityMapLocation>(
            `${this.baseURL}/Competitor/GetFacilityMapLocation?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => res.body as IFacilityMapLocation),
                catchError(this.handleError)
            );
    }

    saveFacilityCompetitorSettings(model: IFacilityCompetitorSettings): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<ISaveDeleteResponse>(
            `${this.baseURL}/Competitor/SaveFacilityCompetitorSettings`, model, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getCandidateCompetitors(facilityId: number, radiusMiles: number): Observable<IFacilityCompetitorCandidate[]> {
        return this.http.get<IFacilityCompetitorCandidate[]>(
            `${this.baseURL}/Competitor/GetCandidateCompetitors?facilityId=${facilityId}&radiusMiles=${radiusMiles}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const candidates = res.body as IFacilityCompetitorCandidate[];
                    return candidates;
                }),
                catchError(this.handleError)
            );
    }

    saveCompetitorCandidates(facilityId: number, candidates: IFacilityCompetitorCandidate[]): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<ISaveDeleteResponse>(
            `${this.baseURL}/Competitor/SaveCompetitorCandidates`,
            { FacilityId: facilityId, Candidates: candidates },
            options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getUnitTypeMappings(facilityId: number): Observable<IUnitTypeMappingSummary> {
        return this.http.get<IUnitTypeMappingSummary>(
            `${this.baseURL}/Competitor/GetUnitTypeMappings?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const summary = res.body as IUnitTypeMappingSummary;
                    return summary;
                }),
                catchError(this.handleError)
            );
    }

    overrideUnitTypeMapping(mappingId: number, unitTypeId: number): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<ISaveDeleteResponse>(
            `${this.baseURL}/Competitor/OverrideUnitTypeMapping`,
            { MappingId: mappingId, UnitTypeId: unitTypeId },
            options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    saveUnitTypeMappings(facilityId: number, mappings: { MappingId: number; UnitTypeId: number | null }[]): Observable<ISaveDeleteResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<ISaveDeleteResponse>(
            `${this.baseURL}/Competitor/SaveUnitTypeMappings`,
            { FacilityId: facilityId, Mappings: mappings },
            options)
            .pipe(catchError(this.handleError));
    }

    requestCompetitorSync(facilityId: number): Observable<ISaveDeleteResponse> {
        return this.http.post<ISaveDeleteResponse>(
            `${this.baseURL}/Competitor/RequestCompetitorSync?facilityId=${facilityId}`,
            null)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
    private handleHttpPostError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error);
            return of(result as T);
        };
    }

    getStorTrackFacilityDetails(facilityId: number): Observable<IStorTrackFacilityDetails> {
        return this.http.get<IStorTrackFacilityDetails>(
            `${this.baseURL}/CompetitorRate/GetStorTrackDashboardOverview?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => res.body as IStorTrackFacilityDetails),
                catchError(this.handleError)
            );
    }

    getCompetitorRateComparison(facilityId: number, unitTypeId: number): Observable<ICompetitorRateComparisonRow[]> {
        return this.http.get<ICompetitorRateComparisonRow[]>(
            `${this.baseURL}/CompetitorRate/GetCompetitorRateComparison?facilityId=${facilityId}&unitTypeId=${unitTypeId}`,
            { observe: 'response' })
            .pipe(
                map(res => res.body as ICompetitorRateComparisonRow[]),
                catchError(this.handleError)
            );
    }
}
